<template>
  <div class="px-3 px-md-0">
    <div class="row">
      <div class="col-12 mb-3">
        <h2 class="text-blue font-weight-bold">
          {{ time | dateLong }} &bull;
          {{ time | clock }}
          {{ $t("uhr") }}
        </h2>
      </div>
    </div>
    <h3 class="mb-3">{{ $t("head_behandlerselect") }}</h3>
    <div class="row">
      <div
        class="col-md-3 behandlerselect text-center mb-3 mb-md-0"
        v-for="p in termine"
        :key="getProposalMitarbeiter(p).mitarbeiter_id"
        @click="selectProposal(p)"
      >
        <div class="rounded-circle bg-white avatar-wrapper ml-auto mr-auto">
          <img
            v-if="getProposalMitarbeiter(p).bild_profil"
            class="avatar_big"
            :src="getBild(getProposalMitarbeiter(p).bild_profil)"
          />
        </div>
        <br />
        <div class="text-dark">
          {{ getProposalMitarbeiter(p).vorname }}
          {{ getProposalMitarbeiter(p).name }}
        </div>
      </div>
      <div
        class="col-md-3 behandlerselect text-center mb-3 mb-md-0"
        @click="selectProposal(termine[0])"
      >
        <avatar-dummy />
        <br />
        <div class="text-dark">{{ $t('actions.ich_moechte_mich_nicht_entscheiden') }} </div>
      </div>
    </div>
    <zurueck-button
      class="Xposition-absolute"
      style="bottom: 5px; left: 30px"
      @click="unselectTime"
    />
  </div>
</template>

<script>
import {
  SET_SELECTED_DAY,
  SET_SELECTED_ROW,
  SET_SELECTED_TERMIN,
} from "@/store/mutations.type";
import { DateTime } from "luxon";

export default {
  name: "TerminauswahlComponent",
  computed: {
    termin() {
      return this.$store.state.termin.selectedProposals;
    },
    time() {
      return DateTime.fromISO(this.termin.proposals[0].start).toJSDate();
    },
    selectedDay: {
      get() {
        return this.$store.state.termin.selectedDay;
      },
      set(val) {
        this.$store.commit(`termin/${SET_SELECTED_DAY}`, val);
      },
    },
    selectedRow: {
      get() {
        return this.$store.state.termin.selectedRow;
      },
      set(val) {
        this.$store.commit(`termin/${SET_SELECTED_ROW}`, val);
      },
    },
    selectedTermin: {
      get() {
        return this.$store.state.termin.selectedTermin;
      },
      set(val) {
        this.$store.commit(`termin/${SET_SELECTED_TERMIN}`, val);
      },
    },
    terminart() {
      return this.$store.state.termin.behandlung;
    },
    termine() {
      return this.termin.proposals.map(p => {
        p.mitarbeiter_2 = this.$store.state.behandlerlist.find(b => b.id === p.mitarbeiter.mitarbeiter_id);
        return p;
      }).sort((a, b) => {
        // sortiere nach Prio an Terminart, wenn existent
        if (a.mitarbeiter_2?.terminart_prio && b.mitarbeiter_2?.terminart_prio)
          return (b.mitarbeiter_2.terminart_prio[this.terminart?.id || ''] || 0) - (a.mitarbeiter_2.terminart_prio[this.terminart?.id || ''] || 0);
        // sonst nach altem Feld
        return (b.mitarbeiter_2?.prio || 0) - (a.mitarbeiter_2?.prio || 0);
      });
    }
  },
  methods: {
    selectProposal(val) {
      this.selectedTermin = val;
    },
    unselectTime() {
      this.selectedDay = null;
      this.selectedRow = null;
    },
    getProposalMitarbeiter(prop) {
      if (Array.isArray(prop.mitarbeiter)) return prop.mitarbeiter[0] || {};
      return prop.mitarbeiter || {};
    },
  },
};
</script>

<style lang="scss" scoped>
</style>
